module.exports = __webpack_public_path__ + "media/react/b2b/app/pages/student/student_report/science-11864fc77401c6a9ec45f653155caf7f.svg";